import React, { useState } from "react";
import {
    Box,
    Typography,
    Button,
    InputLabel,
    CircularProgress,
    Select,
    MenuItem,
    FormControl,

} from "@mui/material";


export const DiseñoFormDos = ({ formData,
    Categoria,
    handleInputChange,
    coloresDisponibles,
    TipoProducto,
    handleFileChange,
    handleSubmit,
    loading
}) => {
    const backendURL = process.env.REACT_APP_BACKEND_URL;
    const [caracteristicaCount, setCaracteristicaCount] = useState(1);
    const [BeneficioCount, setBeneficioCount] = useState(1);

    const handleAddCaracteristica = () => {
        if (caracteristicaCount < 10) {
            setCaracteristicaCount((prev) => prev + 1);
        }
    };
    const handleAddBeneficio = () => {
        if (BeneficioCount < 7) {
            setBeneficioCount((prev) => prev + 1);
        }
    };
    const renderPreview = (file) => {
        if (!file) return null;
        const url = typeof file === "string" ? `${backendURL}/${file}` : URL.createObjectURL(file);
        return <img src={url} alt="preview" style={{ width: "100%", marginBottom: 10 }} />;
    };

    const renderDeviceCaracteristicasInputs = () => {
        const deviceFields = [
            "caracteristica",
            "caracteristica1",
            "caracteristica2",
            "caracteristica3",
            "caracteristica4",
            "caracteristica6",
            "caracteristica7",
            "caracteristica8",
            "caracteristica9",
            "caracteristica10",

        ];
        return deviceFields.slice(0, caracteristicaCount).map((field, index) => (
            <div key={field} style={{ marginBottom: "15px" }}>
                <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>
                    Característica de la máquina {index === 0 ? "" : index}
                </InputLabel>

                <input
                    type="text"
                    name={field}
                    value={formData[field] || ""}
                    onChange={handleInputChange}
                    style={{ border: "2px solid #585857", color: '#585857', background: '#fff', padding: "8px", borderRadius: "6px", width: "100%" }}

                />
            </div>
        ));
    };



    const renderDeviceBeneficioInputs = () => {
        const deviceFields = [
            "beneficio",
            "beneficio1",
            "beneficio2",
            "beneficio3",
            "beneficio4",
            "beneficio5",
            "beneficio6",
        ];
        return deviceFields.slice(0, BeneficioCount).map((field, index) => (
            <div key={field} style={{ marginBottom: "15px" }}>
                <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>
                    Beneficio de la máquina {index === 0 ? "" : index}
                </InputLabel>

                <input
                    type="text"
                    name={field}
                    value={formData[field] || ""}
                    onChange={handleInputChange}
                    style={{ border: "2px solid #585857", color: '#585857', background: '#fff', padding: "8px", borderRadius: "6px", width: "100%" }}

                />
            </div>
        ));
    };

    return (
        <Box>
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
                <div>
                    <FormControl
                        fullWidth
                        margin="normal"
                        sx={{
                            border: "2px solid #585857",
                            borderRadius: "6px",
                            "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                            },
                        }}
                    >
                        <InputLabel id="categoria-select-label">Categoría</InputLabel>
                        <Select
                            labelId="categoria-select-label"
                            value={formData.categoria_id}
                            label="Categoría"
                            sx={{
                                color: '#585857'
                            }}
                            onChange={handleInputChange}
                            name="categoria_id"
                        >
                            {Categoria.map((categoria) => (
                                <MenuItem
                                    key={categoria.id}
                                    value={categoria.id}
                                    sx={{
                                        backgroundColor: "#fff",
                                        color: "#585857",
                                        textTransform: 'capitalize',
                                        "&:hover": {
                                            backgroundColor: "#f0f0f0",
                                        },
                                    }}>
                                    <p>{categoria.titulo}  {categoria.titulo1}</p>
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
                <div>
                    <FormControl
                        fullWidth
                        margin="normal"
                        sx={{
                            border: "2px solid #585857",
                            borderRadius: "6px",
                            "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                            },
                        }}
                    >
                        <InputLabel id="categoria-select-label">Tipo Producto</InputLabel>
                        <Select
                            labelId="categoria-select-label"
                            value={formData.tipo_producto}
                            label="Tipo producto"
                            sx={{
                                color: '#585857'
                            }}
                            onChange={handleInputChange}
                            name="tipo_producto"
                        >
                            {TipoProducto.map((categoria) => (
                                <MenuItem
                                    key={categoria}
                                    value={categoria}
                                    sx={{
                                        backgroundColor: "#fff",
                                        color: "#585857",
                                        textTransform: 'capitalize',
                                        "&:hover": {
                                            backgroundColor: "#f0f0f0",
                                        },
                                    }}>
                                    {categoria}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Imagen Producto</InputLabel>
                    {renderPreview(formData.imagen_producto)}
                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleFileChange(e, "imagen_producto")}
                        style={{ border: "2px solid #585857", padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Logo Empresa Maquina</InputLabel>
                    {renderPreview(formData.logo_empresa_maquina)}
                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleFileChange(e, "logo_empresa_maquina")}
                        style={{ border: "2px solid #585857", padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Titulo Maquina</InputLabel>

                    <input
                        name="titulo_maquina"
                        label="Título"
                        value={formData.titulo_maquina}
                        onChange={handleInputChange}
                        style={{ border: "2px solid #585857", color: '#585857', background: '#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>

                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Nombre Maquina</InputLabel>

                    <input
                        name="nombre_maquina"
                        label="Título"
                        value={formData.nombre_maquina}
                        onChange={handleInputChange}
                        style={{ border: "2px solid #585857", color: '#585857', background: '#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Texto innovación</InputLabel>

                    <input
                        name="texto_innovacion"
                        label="Título"
                        value={formData.texto_innovacion}
                        onChange={handleInputChange}
                        style={{ border: "2px solid #585857", color: '#585857', background: '#fff', padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Imagen caracteristica</InputLabel>
                    {renderPreview(formData.imagen_dispositivo)}
                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleFileChange(e, "imagen_dispositivo")}
                        style={{ border: "2px solid #585857", padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>
                <div>
                    {renderDeviceCaracteristicasInputs()}
                    {caracteristicaCount < 10 && (
                        <Button
                            variant="outlined"
                            onClick={handleAddCaracteristica}
                            sx={{ marginTop: "10px", backgroundColor: '#1A425B', textTransform: 'capitalize' }}
                        >
                            Agregar otra característica de imagen
                        </Button>
                    )}
                </div>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Imagen caracteristica dos</InputLabel>
                    {renderPreview(formData.imagen_dispositivo1)}
                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleFileChange(e, "imagen_dispositivo1")}
                        style={{ border: "2px solid #585857", padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>
                <div>
                    {renderDeviceBeneficioInputs()}
                    {BeneficioCount < 7 && (
                        <Button
                            variant="outlined"
                            onClick={handleAddBeneficio}
                            sx={{ marginTop: "10px", backgroundColor: '#1A425B', textTransform: 'capitalize' }}
                        >
                            Agregar otro caracteristica imagen 2
                        </Button>
                    )}
                </div>
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Imagen tabla producto</InputLabel>
                    {renderPreview(formData.logo_dispositivo)}
                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleFileChange(e, "logo_dispositivo")}
                        style={{ border: "2px solid #585857", padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>
                <FormControl
                    fullWidth
                    sx={{
                        border: "2px solid #585857",
                        borderRadius: "6px",
                        "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                        },
                    }}
                >
                    <InputLabel id="color-select-label">Color</InputLabel>
                    <Select
                        labelId="color-select-label"
                        name="color"
                        type="color"
                        value={formData.color}
                        onChange={handleInputChange}
                        renderValue={(selected) => selected}
                    >
                        {coloresDisponibles.map((color) => (
                            <MenuItem
                                key={color}
                                value={color}
                                sx={{
                                    backgroundColor: formData.color === color ? "#e0e0e0" : "#fff",
                                    color: "#585857",
                                    "&:hover": {
                                        backgroundColor: "#f0f0f0",
                                    },
                                }}
                            >

                                {color}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {formData.color && (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            mt: 1,
                        }}
                    >
                        <Typography variant="body1" sx={{ color: '#585857' }}>Este es el color seleccionado:</Typography>
                        <Box
                            sx={{
                                width: 200,
                                height: 24,
                                backgroundColor: formData.color,
                                border: '1px solid #000',
                                borderRadius: '4px',
                            }}
                        />
                        <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                            {formData.color}
                        </Typography>
                    </Box>
                )}
                <div>
                    <InputLabel sx={{ color: "#585857", marginBottom: "5px" }}>Pdf Información producto</InputLabel>
                    <iframe
                        src={`${backendURL}/${formData.pdf}`}
                        title="Vista previa del PDF"
                        width="100%"
                        height="100%"
                        style={{ border: "none", borderRadius: "8px" }}
                    />

                    <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleFileChange(e, "pdf")}
                        style={{ border: "2px solid #585857", padding: "8px", borderRadius: "6px", width: "100%" }}
                    />
                </div>
                <Button
                    variant="contained"
                    disabled={loading}
                    sx={{
                        backgroundColor: "#5E487B",
                        color: "#fff",
                        textTransform: "capitalize"
                    }}
                    type="submit"
                >    {loading ? <CircularProgress size={24} /> : 'Guardar'}

                </Button>
            </form>
        </Box>
    )
}